import { useQuery } from '@tanstack/react-query';
import { estatesService } from '@/services';

/**
 * Returns all co-managers on the estate (everyone except the current user).
 * Static fetch — no Realtime needed.
 */
export function useEstatePresence(estateId, currentUserId) {
  const { data = [] } = useQuery({
    queryKey: ['estate-members', estateId],
    queryFn: () => estatesService.getEstateMembers(estateId),
    enabled: !!estateId,
    staleTime: 5 * 60 * 1000, // 5-minute cache — members don't change often
  });

  return data.filter((m) => m.user_id !== currentUserId);
}
